// @flow
import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';

import PrevNextPages from 'components/page/PrevNextPages';
import PageNodeHeader from 'containers/page/PageNodeHeaderContainer';
import SubRouter from 'components/subRouter/SubRouter';
import Sidebar from 'components/sidebar/Sidebar';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import PageNotFound from 'components/app/PageNotFound';
import Loading from 'components/fragments/Loading';
import { STATUS_UNKNOWN, STATUS_SUCCESS } from 'constants/statusConstants';
import { nullPageNode } from 'types/PageNode';
import { getPublicAssets } from 'utils/assetsUtils';

import type { Match } from 'react-router-dom';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { PageChildType } from 'types/PageNode';
// import

export type OwnProps = {
  location: {
    pathname: string,
    search: string
  }
};

export type DispatchProps = {
  fetchPageDetail: (slug: string) => void,
  fetchPageNode: (slug: string) => void
};

export type StateProps = {
  contentNode: BlocContent[],
  liste_enfants: PageChildType[],
  sidebar_content: BlocContent[],
  pageDetailSidebar: BlocContent[],
  status: Status,
  template: string,
  templateDetail: string,
  redirection: string,
  title_previsu: string
};

type HistoryProps = {
  history: any
};

type Props = {
  pageSlug: string,
  match: Match
} & OwnProps &
  DispatchProps &
  StateProps &
  HistoryProps;

type State = {
  currentPage: string
};

class PageNode extends Component<Props, State> {
  state: State = {
    currentPage: ''
  };
  componentDidMount() {
    const {
      location,
      match: {
        params: { slugNode }
      }
    } = this.props;
    const url = location.pathname.split('/');
    const menuSlug = url[3];

    if (slugNode) {
      this.props.fetchPageNode(slugNode);
      if (menuSlug) {
        this.props.fetchPageDetail(menuSlug);
      }
    } else {
      this.props.fetchPageNode(this.props.pageSlug);
    }

    this.setState({ currentPage: 'ok' });
  }

  componentDidUpdate(prevProps: Props) {
    const {
      location,
      match: {
        params: { slugNode }
      },
      liste_enfants
    } = this.props;
    const {
      location: prevLocation,
      match: {
        params: { slugNode: prevSlugNode }
      },
      liste_enfants: prevListEnfants
    } = prevProps;
    const url = location.pathname.split('/');
    const menuSlug = url[3];
    const prevUrl = prevLocation.pathname.split('/');
    const prevMenuSlug = prevUrl[3];

    if (slugNode && slugNode !== prevSlugNode) {
      this.props.fetchPageNode(slugNode);
    }

    if (menuSlug !== prevMenuSlug) {
      this.props.fetchPageDetail(menuSlug);
    }

    if (liste_enfants !== prevListEnfants) {
      this.props.fetchPageDetail(menuSlug);
    }
  }

  shouldComponentUpdate(nextProps: Props) {
    const { slugNode } = this.props.match.params;
    const { liste_enfants } = this.props;
    if (nextProps.title_previsu !== this.props.title_previsu) {
      return true;
    }
    if (nextProps !== this.props) {
      if (nextProps.match.params.slugNode) {
        if (nextProps.match.params.slugNode !== slugNode) {
          this.props.fetchPageNode(nextProps.match.params.slugNode);
          return liste_enfants !== nextProps.liste_enfants;
        }
      }
      if (nextProps.location.search !== this.props.location.search) {
        return false;
      }

      return true;
    }
    return false;
  }

  renderSubRouter = () => {
    const { liste_enfants, contentNode, match } = this.props;

    if (JSON.stringify(liste_enfants) !== JSON.stringify(nullPageNode.liste_enfants)) {
      return <SubRouter subroutes={liste_enfants} match={match} />;
    }

    return (
      <div className="page">
        {contentNode.map((blocFigure, index) => {
          return <ContentBloc key={index} {...blocFigure} />;
        })}
      </div>
    );
  };

  renderPageNodeHeader = (withTab: boolean = true) => {
    const { liste_enfants, location, title_previsu } = this.props;
    let className = '';

    if (JSON.stringify(liste_enfants) !== JSON.stringify(nullPageNode.liste_enfants) && withTab) {
      const splits = location.pathname.split('/');
      /**
       * Si on est sur une page de prévisu, on ajoute un onglet prévisualisation
       */
      if (/page_/.test(splits[splits.length - 1])) {
        const page_previsu = liste_enfants.filter(function(e) {
          return e.type_name === 'page_previsu';
        });
        const idNum = splits[splits.length - 1].replace('page_', '');
        if (page_previsu.length === 0) {
          const previewPage = {
            menu_order: 0,
            object_id: parseInt(idNum, 10),
            type_name: 'page_previsu',
            object_slug: splits[splits.length - 1],
            title: title_previsu ? title_previsu : 'Prévisualisation'
          };
          liste_enfants.push(previewPage);
        } else if (title_previsu !== '' && page_previsu[0].title === 'Prévisualisation') {
          const previewPageBis = {
            menu_order: 0,
            object_id: parseInt(idNum, 10),
            type_name: 'page_previsu',
            object_slug: splits[splits.length - 1],
            title: title_previsu ? title_previsu : 'Prévisualisation'
          };
          liste_enfants[liste_enfants.length - 1] = previewPageBis;
        }
      }
      return <PageNodeHeader withSubMenu={true} className={className} />;
    }

    return <PageNodeHeader withSubMenu={false} className={className} />;
  };

  renderSidebar = () => {
    const { sidebar_content, pageDetailSidebar, templateDetail } = this.props;
    let sidebarContent;

    if (pageDetailSidebar.length > 0) {
      sidebarContent = pageDetailSidebar;
    } else {
      sidebarContent = sidebar_content;
    }

    if (templateDetail === 'page-academies_rugby' || templateDetail === 'page-academies_poles_espoirs') {
      return null;
    }

    if (templateDetail === 'page-hub_entreprises_salons_seminaires') {
      return null;
    }

    return <Sidebar sidebarContent={sidebarContent} />;
  };

  renderVipBloc = () => {
    return (
      <section className="section section--bg">
        <div className="container">
          <div className="row">
            <div className="col col-lg-6">
              <h2 className="mb-1">Devenez membre VIP du Club 1919</h2>
              <p className="ft-secondary ft-white-secondary mb-3">
                Vivez des instants au plus près des Bleus. Le Club 1919 vous offrira de nombreuses exclusivités tout au
                long de l’année permettant de plonger dans l’univers du XV de France.
              </p>
              <p className="ft-h6 ft-up mb-5">
                Cadeaux
                <span className="bullet">∘</span>
                dîners
                <span className="bullet">∘</span> rencontres avec les joueurs
              </p>
              <a className="btn btn--primary" href="/actualites/entreprises/club-1919-rejoignez-le-club-vip-de-la-ffr">
                Découvrir toutes les exclusivités
              </a>
            </div>
            <div className="col col-lg-6">
              <img className="section__thumbnail" src={getPublicAssets('/img/card/club-1919.jpg')} alt="Club 1919" />
            </div>
          </div>
        </div>
        <div
          className="img-bg img-bg--left"
          style={{ backgroundImage: `url(${getPublicAssets('/img/banner/background-1919.jpg')})` }}
        ></div>
      </section>
    );
  };

  _renderContent = () => {
    const { renderSubRouter, renderSidebar } = this;
    const { liste_enfants, templateDetail } = this.props;

    if (templateDetail === 'page-hub_entreprises_salons_seminaires') {
      return <div className="container">{renderSubRouter()}</div>;
    }

    // /ffr/carriere/offres => 1 élément dans la liste_enfants mais pas d'enfant
    if (templateDetail === 'page-emplois_liste_offre') {
      return (
        <div className="row">
          <div className="col col-md-8 col-lg-9 bg-overflow">{renderSubRouter()}</div>
          {renderSidebar()}
        </div>
      );
    }

    return (
      <div className="row">
        <div className="col col-md-8 col-lg-9 bg-overflow">
          <section>
            <div className="row">
              <div className="col col-lg-8on9">{renderSubRouter()}</div>
            </div>
          </section>
          {liste_enfants && liste_enfants.length > 2 && <PrevNextPages childrenList={liste_enfants} />}
        </div>
        {renderSidebar()}
      </div>
    );
  };

  _renderContentAcademies = () => {
    const { renderSubRouter } = this;

    return <div className="row mb-6 mb-md-7 mb-md-8">{renderSubRouter()}</div>;
  };

  render() {
    const {
      status,
      location: { pathname },
      template,
      templateDetail
    } = this.props;
    const withTab = template !== 'page-hub_entreprises_salons_seminaires';
    if (status === STATUS_UNKNOWN) {
      return <PageNotFound noMargin />;
    }

    if (this.state.currentPage && status === STATUS_SUCCESS) {
      if (pathname.includes('/offre-emploi')) {
        return <Redirect to={pathname.replace('/offre-emploi', '')} />;
      }

      if (templateDetail === 'page-academies_rugby' || templateDetail === 'page-academies_poles_espoirs') {
        return (
          <Fragment>
            {this.renderPageNodeHeader(withTab)}
            <div className="result result-academies">
              <div className="container">{this._renderContentAcademies()}</div>
            </div>
          </Fragment>
        );
      }

      return (
        <Fragment>
          {this.renderPageNodeHeader(withTab)}
          <div className="container">{this._renderContent()}</div>
          {/* {templateDetail === 'page-hub_entreprises_salons_seminaires' && this.renderVipBloc()} */}
        </Fragment>
      );
    }
    return <Loading isBlue backgroundColor={'#013974'} />;
  }
}

export default PageNode;
